<script lang="ts">
  import SearchHeader from "~/components/collection/SearchHeader/SearchHeader.svelte";
  import ProductListLayout from "~/components/collection/ProductListLayout/ProductListLayout.svelte";
  import { JsonLd } from "svelte-meta-tags";
  import { buildSearchResultsPageSchema } from "~/lib/structured-data";
  import { SORT_OPTIONS } from "~/lib/bloomreach/config";
  import { createSearchListing } from "~/lib/listings/create-search-listing.svelte";
  import { CARD_SELECTOR } from "~/components/collection/ProductCardGrid/ProductCardGrid.svelte";

  interface Props {
    accountId?: string;
    domainKey?: string;
    rows?: number;
  }

  let { accountId, domainKey, rows }: Props = $props();

  // Props are static island config injected once from Liquid. Pass as getters so
  // Svelte's reactive tracking is satisfied while preserving the initial values.
  const searchListing = createSearchListing({
    cardSelector: CARD_SELECTOR,
    get accountId() {
      return accountId;
    },
    get domainKey() {
      return domainKey;
    },
    get rows() {
      return rows;
    },
  });
  const listing = searchListing.listing;

  const page0Docs = $derived(listing.query.data?.pages[0]?.response?.docs);

  const searchSchema = $derived.by(() => {
    if (!page0Docs?.length) return null;
    const searchUrl = `${window.location.origin}${window.location.pathname}?q=${encodeURIComponent(searchListing.searchQuery)}`;
    return buildSearchResultsPageSchema({
      searchQuery: searchListing.searchQuery,
      url: searchUrl,
      docs: page0Docs,
      activeSort: listing.activeSort,
      currency: window.DUSK?.currency ?? "GBP",
    });
  });
</script>

{#if searchSchema}
  <JsonLd schema={searchSchema} />
{/if}

<SearchHeader
  bind:query={searchListing.pendingSearchQuery}
  settledQuery={searchListing.searchQuery}
  autocorrectQuery={searchListing.autocorrectQuery}
  didYouMean={searchListing.didYouMean}
  onSuggestionClick={searchListing.handleSuggestionClick}
  onRevert={searchListing.revertAutocorrect}
/>

<ProductListLayout
  filters={listing.filters}
  sortOptions={SORT_OPTIONS}
  products={listing.products}
  loading={listing.query.isPending && searchListing.searchQuery !== ""}
  error={listing.isInitialError}
  hasMore={listing.query.hasNextPage}
  loadingMore={listing.query.isFetchingNextPage}
  loadMoreError={listing.isLoadMoreError}
  onLoadMore={searchListing.handleLoadMore}
  resultCount={listing.resultCount}
  bind:activeFilters={listing.pendingFilters}
  sort={listing.activeSort}
  onSortChange={searchListing.handleSortChange}
  onReset={searchListing.handleReset}
/>
